import { render } from "./Completion.vue?vue&type=template&id=1ae4f2aa"
const script = {}
script.render = render

export default script